import React, { Component } from "react";
import { connect } from "react-redux";
import { BsSearch } from "react-icons/bs";
import { AiOutlinePlus } from "react-icons/ai";
import Footer from "../Footer";
import ContentLoader from "react-content-loader";
import { getTeacherChatList } from "../../../redux/Teacher/chat/action";
import { ChatList } from "./ChatList/index";
import Axios from "axios";
import { Modal } from "react-bootstrap";
import { WEBSITE_URL, IMAGE_BASE_URL } from "../../../api";
import teacherImg from "../../../assets/Images/bg.png";

export class TeacherChat extends Component {
    state = {
        loading: false,
        showModal: false,
        parents: [],
        students: [],
        loadingUsers: false,
        searchQuery: "",
        activeTab: "parents", // "parents" | "students"
    };

    componentDidMount() {
        this.setState({ loading: true });
        let staff = null;
        try {
            staff = JSON.parse(localStorage.getItem("teacher"));
        } catch (e) {
            console.log(e);
        }
        const { user } = this.props;
        const token = user?.data?.auth_token;
        const staffId = user?.data?.staff?.id || user?.data?.id || staff?.staff_id || staff?.id;

        if (token) {
            this.props.getTeacherChatList(token, staffId);
        }
        setTimeout(() => {
            this.setState({ loading: false });
        }, 1200);
    }

    fetchModalUsers = (tab = this.state.activeTab) => {
        const { user } = this.props;
        const token = user?.data?.auth_token;
        this.setState({ loadingUsers: true, showModal: true });
        const endpoint = tab === "students" ? "/get-students-for-teacher" : "/get-parents-for-teacher";
        Axios.post(WEBSITE_URL + endpoint, { token })
            .then((res) => {
                if (res.data && res.data.success) {
                    if (tab === "students") {
                        this.setState({ students: res.data.data || [], loadingUsers: false });
                    } else {
                        this.setState({ parents: res.data.data || [], loadingUsers: false });
                    }
                } else {
                    this.setState({ loadingUsers: false });
                }
            })
            .catch(() => {
                this.setState({ loadingUsers: false });
            });
    };

    handleTabChange = (tab) => {
        this.setState({ activeTab: tab });
    };

    render() {
        const { user, chat } = this.props;
        const { activeTab, searchQuery, showModal, loadingUsers, parents, students } = this.state;
        let staff = null;
        try {
            staff = JSON.parse(localStorage.getItem("teacher"));
        } catch (e) {}
        const staffId = user?.data?.staff?.id || user?.data?.id || staff?.staff_id || staff?.id || 1;

        const currentUsers = activeTab === "students" ? students : parents;
        const filteredUsers = currentUsers.filter((u) =>
            u?.name?.toLowerCase().includes(searchQuery.toLowerCase())
        );

        const rawChatList = chat?.chat_list || [];
        const activeTabChats = rawChatList.filter((item) => {
            if (activeTab === "students") {
                return item.is_student === true;
            }
            return !item.is_student;
        });

        return (
            <React.Fragment>
                {this.state.loading ? (
                    <React.Fragment>
                        <ContentLoader
                            viewBox="0 0 280 550"
                            backgroundColor={"#F3F3F3"}
                            foregroundColor={"#FFFFFF"}
                        >
                            <rect
                                x="8"
                                y="18"
                                rx="8"
                                ry="8"
                                width="25"
                                height="29"
                            />
                            <rect
                                x="245"
                                y="18"
                                rx="8"
                                ry="8"
                                width="25"
                                height="29"
                            />
                            <rect
                                x="8"
                                y="67"
                                rx="5"
                                ry="5"
                                width="80"
                                height="20"
                            />
                            <rect
                                x="8"
                                y="100"
                                rx="5"
                                ry="5"
                                width="50"
                                height="10"
                            />
                            <rect
                                x="8"
                                y="130"
                                rx="5"
                                ry="5"
                                width="57"
                                height="22"
                            />
                            <rect
                                x="80"
                                y="130"
                                rx="5"
                                ry="5"
                                width="45"
                                height="22"
                            />
                            <rect
                                x="15"
                                y="180"
                                rx="10"
                                ry="10"
                                width="40"
                                height="40"
                            />
                            <rect
                                x="70"
                                y="185"
                                rx="5"
                                ry="5"
                                width="40"
                                height="15"
                            />
                            <rect
                                x="70"
                                y="205"
                                rx="5"
                                ry="5"
                                width="30"
                                height="10"
                            />
                            <rect
                                x="15"
                                y="240"
                                rx="10"
                                ry="10"
                                width="40"
                                height="40"
                            />
                            <rect
                                x="70"
                                y="240"
                                rx="5"
                                ry="5"
                                width="45"
                                height="15"
                            />
                            <rect
                                x="70"
                                y="265"
                                rx="5"
                                ry="5"
                                width="65"
                                height="10"
                            />
                            <rect
                                x="15"
                                y="300"
                                rx="10"
                                ry="10"
                                width="40"
                                height="40"
                            />
                            <rect
                                x="70"
                                y="300"
                                rx="10"
                                ry="10"
                                width="45"
                                height="15"
                            />

                            <rect
                                x="70"
                                y="330"
                                rx="5"
                                ry="5"
                                width="65"
                                height="10"
                            />
                            <rect
                                x="15"
                                y="365"
                                rx="10"
                                ry="10"
                                width="40"
                                height="40"
                            />
                            <rect
                                x="70"
                                y="365"
                                rx="10"
                                ry="10"
                                width="45"
                                height="15"
                            />
                            <rect
                                x="70"
                                y="390"
                                rx="5"
                                ry="5"
                                width="65"
                                height="10"
                            />
                            <rect
                                x="15"
                                y="430"
                                rx="10"
                                ry="10"
                                width="40"
                                height="40"
                            />
                            <rect
                                x="70"
                                y="430"
                                rx="10"
                                ry="10"
                                width="45"
                                height="15"
                            />
                            <rect
                                x="70"
                                y="460"
                                rx="5"
                                ry="5"
                                width="65"
                                height="10"
                            />
                            <rect
                                x="15"
                                y="525"
                                rx="12"
                                ry="12"
                                width="250"
                                height="35"
                            />
                        </ContentLoader>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <div className="">
                            <div className="d-flex justify-content-between align-items-center px-3 py-3">
                                <div onClick={() => this.fetchModalUsers()} style={{ cursor: "pointer" }}>
                                    <BsSearch style={{ fontSize: "18px" }} />
                                </div>
                                <div onClick={() => this.fetchModalUsers()} style={{ cursor: "pointer" }}>
                                    <AiOutlinePlus style={{ fontSize: "22px", color: "#c1486f" }} />
                                </div>
                            </div>

                            {/* 2 Tabs: Parents and Students */}
                            <div className="d-flex px-3 mb-3" style={{ gap: "10px" }}>
                                <button
                                    onClick={() => this.handleTabChange("parents")}
                                    className="btn flex-fill py-2"
                                    style={{
                                        backgroundColor: activeTab === "parents" ? "#c1486f" : "#F8F9FA",
                                        color: activeTab === "parents" ? "#FFFFFF" : "#6C757D",
                                        border: activeTab === "parents" ? "1px solid #c1486f" : "1px solid #CED4DA",
                                        borderRadius: "12px",
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        boxShadow: activeTab === "parents" ? "0 4px 10px rgba(193, 72, 111, 0.25)" : "none",
                                        transition: "all 0.2s ease"
                                    }}
                                >
                                    Parents
                                </button>
                                <button
                                    onClick={() => this.handleTabChange("students")}
                                    className="btn flex-fill py-2"
                                    style={{
                                        backgroundColor: activeTab === "students" ? "#c1486f" : "#F8F9FA",
                                        color: activeTab === "students" ? "#FFFFFF" : "#6C757D",
                                        border: activeTab === "students" ? "1px solid #c1486f" : "1px solid #CED4DA",
                                        borderRadius: "12px",
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        boxShadow: activeTab === "students" ? "0 4px 10px rgba(193, 72, 111, 0.25)" : "none",
                                        transition: "all 0.2s ease"
                                    }}
                                >
                                    Students
                                </button>
                            </div>

                            <div className="px-3">
                                <span
                                    style={{
                                        color: "#212529",
                                        fontWeight: "400",
                                        fontSize: "20px",
                                    }}
                                >
                                    {activeTab === "parents" ? "Chat With Parents" : "Chat With Students"}
                                </span>
                            </div>
                            {chat && chat.success && (
                                <div className="px-3">
                                    <span
                                        style={{
                                            color: "#ADB5BD",
                                            fontWeight: "400",
                                            fontSize: "11px",
                                        }}
                                    >
                                        {activeTabChats.length} {activeTab === "parents" ? "Parent" : "Student"}{activeTabChats.length === 1 ? "" : "s"}
                                    </span>
                                </div>
                            )}
                            <ChatList 
                                chat={chat}
                                user={user}
                                activeTab={activeTab}
                            />
                            <div>
                                <Footer current={"message"} />
                            </div>
                        </div>

                        {/* New Chat Modal */}
                        <Modal show={showModal} onHide={() => this.setState({ showModal: false })} centered>
                            <Modal.Header closeButton>
                                <Modal.Title style={{ fontSize: "16px", fontWeight: "600" }}>
                                    Start New Chat with {activeTab === "parents" ? "Parent" : "Student"}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
                                <div className="d-flex mb-3" style={{ gap: "8px" }}>
                                    <button
                                        onClick={() => this.fetchModalUsers("parents")}
                                        className="btn btn-sm flex-fill"
                                        style={{
                                            backgroundColor: activeTab === "parents" ? "#c1486f" : "#FFF",
                                            color: activeTab === "parents" ? "#FFF" : "#c1486f",
                                            border: "1px solid #c1486f",
                                            fontWeight: "600"
                                        }}
                                    >
                                        Parents
                                    </button>
                                    <button
                                        onClick={() => this.fetchModalUsers("students")}
                                        className="btn btn-sm flex-fill"
                                        style={{
                                            backgroundColor: activeTab === "students" ? "#c1486f" : "#FFF",
                                            color: activeTab === "students" ? "#FFF" : "#c1486f",
                                            border: "1px solid #c1486f",
                                            fontWeight: "600"
                                        }}
                                    >
                                        Students
                                    </button>
                                </div>
                                <input
                                    type="text"
                                    className="form-control mb-3"
                                    placeholder={`Search ${activeTab === "parents" ? "parent" : "student"} by name...`}
                                    value={searchQuery}
                                    onChange={(e) => this.setState({ searchQuery: e.target.value })}
                                />
                                {loadingUsers ? (
                                    <div className="text-center py-3 text-muted">Loading {activeTab}...</div>
                                ) : filteredUsers.length > 0 ? (
                                    filteredUsers.map((u) => (
                                        <div
                                            key={u.id}
                                            className="d-flex align-items-center justify-content-between p-2 border-bottom"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                this.setState({ showModal: false });
                                                this.props.history.push(`/single-chat-teacher/${u.id}/${staffId}`);
                                            }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <img
                                                    src={u.image ? IMAGE_BASE_URL + u.image : teacherImg}
                                                    alt={u.name}
                                                    style={{ width: "40px", height: "40px", borderRadius: "50%", objectFit: "cover", border: "1px solid #c1486f" }}
                                                />
                                                <div className="ms-3">
                                                    <div className="fw-bold" style={{ fontSize: "14px", color: "#333" }}>{u.name}</div>
                                                    <div className="text-muted" style={{ fontSize: "12px" }}>
                                                        {u.class_info || u.email || (activeTab === "students" ? "Student" : "Parent")}
                                                    </div>
                                                </div>
                                            </div>
                                            <button
                                                className="btn btn-sm text-white px-3"
                                                style={{ backgroundColor: "#c1486f", borderColor: "#c1486f", borderRadius: "6px" }}
                                            >
                                                Chat
                                            </button>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center py-3 text-muted">No {activeTab} found</div>
                                )}
                            </Modal.Body>
                        </Modal>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.teacher.teacher,
    chat: state.teacherChat.chat_list,
});

export default connect(mapStateToProps, {
    getTeacherChatList,
})(TeacherChat);
